document.addEventListener("DOMContentLoaded", () => {
  const tocRoot = document.querySelector("[data-toc]");
  if (!tocRoot) return;

  // Treść artykułu (u Ciebie: .article__content.rte)
  const articleContent = document.querySelector(".article__content.rte");
  if (!articleContent) {
    tocRoot.style.display = "none";
    return;
  }

  // 1) Znajdź pierwsze H2 (TOC ma być przed nim)
  const firstH2 = articleContent.querySelector("h2");

  // 2) Znajdź pierwszy akapit (lead) PRZED pierwszym H2
  const paragraphs = [...articleContent.querySelectorAll("p")];
  let leadP = null;

  if (firstH2) {
    leadP = paragraphs.find(p => {
      // czy ten <p> jest przed firstH2 w DOM?
      const pos = p.compareDocumentPosition(firstH2);
      return (pos & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
    });
  } else {
    // jeśli nie ma H2, bierz pierwszy akapit w ogóle
    leadP = paragraphs[0] || null;
  }

  // 3) Przenieś TOC we właściwe miejsce:
  // - najlepiej po leadP
  // - w innym wypadku przed firstH2
  // - a jeśli nie ma ani leadP ani H2, to ukryj (bo nie ma sensu)
  if (leadP) {
    leadP.insertAdjacentElement("afterend", tocRoot);
  } else if (firstH2) {
    firstH2.insertAdjacentElement("beforebegin", tocRoot);
  } else {
    tocRoot.style.display = "none";
    return;
  }

  // ---- Generowanie spisu treści ----
  const headings = [...articleContent.querySelectorAll("h2, h3")]
    .filter(h => h.textContent && h.textContent.trim().length > 0);

  if (headings.length < 2) {
    tocRoot.style.display = "none";
    return;
  }

  const nav = tocRoot.querySelector(".toc__nav");
  if (!nav) return;

  nav.innerHTML = "";

  const ul = document.createElement("ul");
  ul.className = "toc__list";
  let currentSublist = null;

  const slugify = (str) =>
    str.toLowerCase()
      .trim()
      .replace(/[\u0105\u0107\u0119\u0142\u0144\u00f3\u015b\u017a\u017c]/g, m => ({
        "ą":"a","ć":"c","ę":"e","ł":"l","ń":"n","ó":"o","ś":"s","ź":"z","ż":"z"
      }[m] || m))
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  const used = new Set();

  const ensureId = (h) => {
    if (h.id) return h.id;
    const base = slugify(h.textContent) || "sekcja";
    let id = base;
    let i = 2;
    while (used.has(id) || document.getElementById(id)) {
      id = `${base}-${i++}`;
    }
    used.add(id);
    h.id = id;
    return id;
  };

  headings.forEach((h) => {
    const level = h.tagName.toLowerCase();
    const id = ensureId(h);

    const li = document.createElement("li");
    li.className = `toc__item toc__item--${level}`;

    const a = document.createElement("a");
    a.className = "toc__link reversed-link";
    a.href = `#${id}`;
    a.textContent = h.textContent.trim();

    li.appendChild(a);

    if (level === "h2") {
      ul.appendChild(li);
      currentSublist = null;
    } else {
      const last = ul.lastElementChild;
      if (!last) {
        ul.appendChild(li);
        return;
      }
      if (!currentSublist) {
        currentSublist = document.createElement("ul");
        currentSublist.className = "toc__sublist";
        last.appendChild(currentSublist);
      }
      currentSublist.appendChild(li);
    }
  });

  nav.appendChild(ul);

  nav.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    history.pushState(null, "", link.getAttribute("href"));
  });
});
